import React from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { TIPI_ABITAZIONE, GARANZIE } from "../../constants";

export default function PropertyDetailsStep({
  formData,
  errors,
  handleInputChange,
  handleCheckboxChange,
  handleIndietro,
  handleSubmitPreventivo,
  onReset,
}) {
  return (
    <Box>
      <Stack direction="row" spacing={1} alignItems="center" mb={4}>
        <HomeRoundedIcon color="primary" fontSize="large" />
        <Typography variant="h5" fontWeight={700}>
          La Tua Abitazione
        </Typography>
      </Stack>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <FormControl
            fullWidth
            required
            size="small"
            error={errors.tipoAbitazione}
          >
            <InputLabel>Tipo di Abitazione</InputLabel>
            <Select
              value={formData.tipoAbitazione}
              label="Tipo di Abitazione"
              onChange={handleInputChange("tipoAbitazione")}
            >
              {TIPI_ABITAZIONE.map((tipo) => (
                <MenuItem key={tipo} value={tipo}>
                  {tipo}
                </MenuItem>
              ))}
            </Select>
            {errors.tipoAbitazione && (
              <Typography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, ml: 1.75 }}
              >
                Inserisci Tipo di Abitazione
              </Typography>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Metri Quadri"
            placeholder="Es. 100"
            type="number"
            value={formData.metriQuadri}
            onChange={handleInputChange("metriQuadri")}
            variant="outlined"
            required
            error={errors.metriQuadri}
            helperText={errors.metriQuadri ? "Inserisci Metri Quadri" : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Anno di Costruzione"
            placeholder="Es. 1990"
            type="number"
            value={formData.annoCostruzione}
            onChange={handleInputChange("annoCostruzione")}
            variant="outlined"
            required
            error={errors.annoCostruzione}
            helperText={
              errors.annoCostruzione ? "Inserisci Anno di Costruzione" : ""
            }
          />
        </Grid>
      </Grid>

      <Box mt={4}>
        <Typography variant="h6" fontWeight={700} mb={2}>
          Garanzie Desiderate
        </Typography>
        <FormGroup>
          <Grid container>
            {Object.entries(GARANZIE).map(([key, label]) => (
              <Grid item xs={12} sm={6} key={key}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.garanzie[key]}
                      onChange={handleCheckboxChange(key)}
                    />
                  }
                  label={label}
                />
              </Grid>
            ))}
          </Grid>
        </FormGroup>
      </Box>

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mt={4}
        spacing={2}
      >
        <Button variant="outlined" onClick={handleIndietro} size="large">
          Indietro
        </Button>
        <Box display="flex" gap={2}>
          <Button variant="outlined" onClick={onReset} size="large">
            Reset Campi
          </Button>
          <Button
            variant="contained"
            endIcon={<ArrowForwardRoundedIcon />}
            onClick={handleSubmitPreventivo}
            size="large"
            sx={{
              bgcolor: "#4caf50",
              "&:hover": { bgcolor: "#45a049" },
            }}
          >
            Ottieni Preventivi Gratuiti
          </Button>
        </Box>
      </Stack>
    </Box>
  );
}
